import { render, staticRenderFns } from "./InstallWater.vue?vue&type=template&id=3743f170&scoped=true"
import script from "./InstallWater.vue?vue&type=script&lang=js"
export * from "./InstallWater.vue?vue&type=script&lang=js"
import style0 from "./InstallWater.vue?vue&type=style&index=0&id=3743f170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3743f170",
  null
  
)

export default component.exports